import { BusyError } from './errors';

export class ConcurrencyLimiter {
  private active = 0;

  constructor(private readonly max: number) {}

  async run<T>(task: () => Promise<T>): Promise<T> {
    if (this.active >= this.max) {
      throw new BusyError();
    }
    this.active += 1;
    try {
      return await task();
    } finally {
      this.active -= 1;
    }
  }
}
